import registerPrompt from 'emun.auth/register-consumer-prompt'
import registerRetailerPrompt from 'emun.auth/register-retailer-prompt'

import $session from 'servicestack/session'

function RegisterConsumerPromptDirectiveFactory( $parse) {
    return {
        scope: false,
        link: function (scope, element, attr) {
            var ngModel = {
                open(e) {
                    var fn = $session.availableBusinessModels.indexOf('Wholesale') != -1 && $session.availableBusinessModels.length == 1 ? registerRetailerPrompt:registerPrompt;
                    return fn(attr).then(
                    args => $parse(attr.onRegistered)(scope, args),
                    args => $parse(attr.onDismissed)(scope, args)
                    );
                }
            }

            if (attr.ngModel) $parse(attr.ngModel).assign(scope, ngModel);

            var $targets = (attr.registerPromptSelector ? element.find(attr.registerPromptSelector) : element);
            $targets.on('click', ngModel.open);
        }
    }
};

export default RegisterConsumerPromptDirectiveFactory;